import { useRelevantCollections } from 'marketplace-ui-common/collections/hooks/useRelevantCollections';
import { useAppContext } from '../../context/AppContext';
export function useUmbrellaCollectionSections(umbrellaCollection) {
  const appContext = useAppContext();
  const {
    data,
    error,
    loading
  } = useRelevantCollections({
    appContext,
    offeringType: 'APP'
  });
  const matchingCollections = data.filter(collection => umbrellaCollection === null || umbrellaCollection === void 0 ? void 0 : umbrellaCollection.collectionIds.includes(collection.id));

  // Create sections for each matching collection
  const sections = matchingCollections.map(collection => {
    var _collection$title;
    return {
      collectionId: collection.id,
      collectionSlug: collection.slug,
      description: collection.tagline,
      imageUrl: undefined,
      // Collections don't have images in the current structure
      title: (_collection$title = collection.title) !== null && _collection$title !== void 0 ? _collection$title : collection.name
    };
  });
  return {
    error: error ? new Error('Failed to load collections') : undefined,
    loading,
    sections
  };
}